import type { ChannelPerson } from './channelPerson';
import type { Attachment } from './attachments';
import type { ResponseWait } from './responseTime';
import type { MessageText, MessageEntity } from './messageMarkup';

export interface MessageAuthor {
  id: string;
  name: string;
  avatar?: string;
}
export interface MessageReaction {
  id: string;
  emoji: string;
  label: string;
  count: number;
  selected?: boolean;
  people?: string[];
}
export interface ConversationMessage {
  id: string;
  author: MessageAuthor;
  sentAt: string;
  content: MessageText;
  source?: { label: string; channel: string };
  quote?: { author: string; content: MessageText };
  attachments?: Attachment[];
  reactions?: MessageReaction[];
  editedAt?: string;
  /** Optional optimistic state; existing received messages keep their presentation. */
  pending?: boolean;
  receipt?: 'sent' | 'delivered' | 'read';
  response?: ResponseWait;
}
export interface ConversationThread {
  message: ConversationMessage;
  replies?: ConversationMessage[];
}
export interface MessageActions {
  /** Optional explicit identity data for hover/focus summaries. */
  people?: readonly ChannelPerson[];
  entities?: readonly MessageEntity[];
  timeZone?: string;
  /** Optional controlled clock for previews/server time. Omit for live wall-clock updates. */
  responseNow?: number;
  onEntityOpen?: (entity: MessageEntity, trigger: HTMLButtonElement) => void;
  onAttachmentOpen?: (file: Attachment, trigger: HTMLButtonElement) => void;
  onReaction?: (messageId: string, reactionId: string) => void;
}
export function messageTime(at: string, timeZone = 'Europe/Moscow', full = false): string {
  const date = new Date(at);
  if (!Number.isFinite(date.getTime())) return 'Время неизвестно';
  return new Intl.DateTimeFormat('ru-RU', {
    timeZone,
    ...(full ? { day: '2-digit', month: 'long', year: 'numeric', timeZoneName: 'short' } : {}),
    hour: '2-digit',
    minute: '2-digit',
  }).format(date);
}
